import dateformat from "dateformat";
import { DEFAULT_CONTACT_DETAILS, tripAttr } from "./../../../config/constants";
import { createSelector } from "reselect";
import { AppState } from "../../../../store";
import { convert24To12Format } from '../../../config/utils';
import { pageMakerSelector } from "./../../../common/redux/selector";
import { commonParseQuery } from "../../../../../../../cars/cars-utils/src/common-utils";
export const reviewSelector = (state: AppState) => state.review;
export const srpSelector = (state: AppState) => state.srp;
export const reviewResultsSelector = createSelector(
  reviewSelector,
  (item) => item?.reviewResults || {}
);
export const loaderSelector = createSelector(
  reviewSelector,
  (item) => item?.loaders || {}
);

export const reviewSelectedSelector = createSelector(
  reviewSelector,
  (item) => item?.reviewSelectedData || {}
);

export const travellerError = createSelector(
  reviewSelector,
  (item) => item?.travellerError || { first_name: {}, email: {}, phone_number: {} }
)

export const travellerDetailsSelector = createSelector(
  reviewSelector,
  (item) => item?.travellerDetails || {}
);

export const travellerTitleDetailsSelector = createSelector(
  reviewSelector,
  (item) => item?.contact_details || DEFAULT_CONTACT_DETAILS
);

export const reviewHeaderSelector = createSelector(
  reviewResultsSelector,
  (item) => {
    const {
      source_city = "",
      destination_city = "",
      destination = "",
      trip_type = "",
      start_time = new Date(),
      source = ""
    } = item;
    const tripType = tripAttr[trip_type]?.name;
    const newDate = new Date(start_time);
    const dateString = `${dateformat(
      newDate,
      "dd mmm' yy"
    )} - ${convert24To12Format(newDate)}`;
    return {
      source_city,
      destination_city,
      source,
      destination,
      tripType,
      dateString
    };
  }
);

export const reviewdetailsSelector = createSelector(
  reviewResultsSelector,
  (item) => {
    const { t = "", st = "", img_url = "", category = "", tool_tip = "", details = [], c_a = [], c_i = [], h_p = "", fuel = {}, c_a_f = {}, h = ""} = item;
    return {
      t,
      st,
      img_url,
      category,
      tool_tip,
      details,
      c_a,
      c_i,
      h_p,
      fuel,
      c_a_f, 
      h
    };
  }
);

export const sourceDestinationSelector = createSelector(
  reviewResultsSelector,
  (item) => {
    const { destination, destination_id, source, source_id } = item;
    const sour = {
      name: source,
      place_id: source_id
    };
    const dest = {
      name: destination,
      place_id: destination_id
    };
    return {
      source: sour,
      destination: dest
    };
  }
);

export const cabDetailsSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.cab_driver_details || {}
);

// fetching dbgDetails for bluSmart in review page
export const dbgDetailsSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.dbg || {}
);

export const driverProfileSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.driver_profile || {}
);
export const cabImagesSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.cab_images_data || {}
);
export const easyBoardingSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.easy_boarding_steps || {}
);

export const isAirportTripSelector = createSelector(
  reviewResultsSelector,
  (item) => !!(item?.trip_type === 'AIRPORT') || false
);

export const cancellationSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.cancellation_charges_window || {}
);

export const inclusionExclusionSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.inclusion_exclusion || {}
);

export const reviewsDataSelector = createSelector(
  reviewSelector,
  (item) => item?.reviews || {}
);

export const fareSelector = createSelector(
  reviewSelector,
  (item) => item?.priceDetails || {}
);

export const paymentSelector = createSelector(
  fareSelector,
  (item) => item?.payment_options || {}
);

export const otherInformationSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.other_information || {}
);

export const safetyInformationSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.safety_details?.data || {}
);

export const reviewRatingDataSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.rnr || {}
);

export const reasonSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.reasons || {}
);

export const offersSelector = createSelector(
  fareSelector,
  (item) => item?.offers || []
);

export const secureTripSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.insurance || {}
);

export const specialRequestSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.special_request || {}
);
export const promoDetailsSelector = createSelector(
  fareSelector,
  (item) => item?.promo_details || {}
);

export const gocashSelector = createSelector(
  fareSelector,
  (item) => item?.gocash_data || {}
);

export const goTribeSelector = createSelector(
  reviewSelector,
  (item) => item?.showGoTribe || false
);

export const goTribeDetailsSelector = createSelector(
  reviewSelector,
  (item) => item?.tribeDetails || {}
);

export const isLoggedInSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.is_logged_in || false
);

export const srcDescSelector = createSelector(
  reviewResultsSelector,
  (item) => {
    const { destination_id = "", destination = "", source_id = "", source = "", start_time = "", end_time = "" } = item;
    const { newSDate, newSTime, newEDate, newETime } = commonParseQuery({ s_t: start_time, e_t: end_time, off: 0, r_off: 0 });
    const data = {
      source: {
        name: source,
        place_id: source_id
      },
      destination: {
        name: destination,
        place_id: destination_id
      },
      startDate: {
        date: newSDate,
        time: newSTime[0]
      },
      endDate: {
        date: newEDate,
        time: newETime[1]
      },
    }
    return data || {};
  }
);

export const popupSelector = createSelector(
  reviewResultsSelector,
  (item) => {
    const data = { ...item.popup, ...{ action: item.action }};
    return data;
  }
);

export const exactLocationApplicableSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.exact_location_applicable || false);

export const paydataSelector = createSelector(
  reviewSelector,
  (item) => item?.paydata || {});

export const AddressUpdateSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.isAdreesUpdate || '');

export const preAppliedPromoSelector = createSelector(
  srpSelector,
  (item) => item?.selectedCab?.pc || ''
);

export const caSelector = createSelector(
  [pageMakerSelector],
  (pageMaker) => {
    const item = pageMaker?.['cabs_dweb_review']?.c_a || {};
    return item || {};
  }
);
export const specialInfoSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.special_info || {}
);

export const dispatchSearchIdSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.dispatch_search_id || ''
);

// getting flagInfo for review page
export const flagsInfoSelector = createSelector(
  reviewResultsSelector,
  (item) => item?.flags || []
);

export const displayGstinSelector = createSelector(
  reviewSelector,
  (item) => item?.displayGstin || false
);

export const sourceAsGstinSelector = createSelector(
  reviewSelector,
  (item) => item?.sourceAsGstin
);


